<template>
  <div id="root" class="text-black text-center flex flex-col justify-center">
    <div class="title">{{ this.$root.print.title }}</div>
    <div class="coordinate">{{ this.$root.print.subtitle }}</div>
  </div>
</template>

<script>
export default {
  name: "TitleDescriptionBlock"
}
</script>

<style scoped>
.title {
  font-size: 39px;
  white-space: pre-line;
  text-align: center;
  word-wrap: break-word;
  display: inline-block;
  z-index: 100;
  padding: 0 20px;
  line-height: 1.1;

  font-family: 'Open Sans', serif;
  font-weight: bold;
  text-transform: uppercase;
}

.coordinate {
  font-family: 'Open Sans', serif;
  font-size: 18px;
  text-align: center;
}

</style>